const colors = [
    {title:'orange' , file:'orange-color.png' , description:''},
    {title:'lemonyellow' , file:'lemonyellow-color.png' , description:''},
    {title:'deepgreen' , file:'deepgreen-color.png' , description:''},
    {title:'red' , file:'red-color.png' , description:''},
]

export default colors;